module.exports = __webpack_public_path__ + "static/media/angular-icon.dcc6bcac.png";